import { useState } from "react";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileSpreadsheet, FileText, Download } from "lucide-react";

export default function Reports() {
  const [loading, setLoading] = useState("");

  const exportCsv = async (kind) => {
    setLoading(kind);
    try {
      const token = localStorage.getItem("dmi_token");
      const res = await fetch(`${API}/reports/export?kind=${kind}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Export gagal");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${kind}_report_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Laporan ${kind} berhasil diunduh`);
    } catch (e) {
      toast.error("Gagal mengunduh laporan");
    } finally {
      setLoading("");
    }
  };

  const printPdf = () => {
    toast.success("Membuka dialog cetak PDF");
    window.print();
  };

  const cards = [
    { kind: "sales", title: "Laporan Penjualan Afiliasi", desc: "Detail order, GMV, komisi talent & revenue agency per transaksi.", icon: FileSpreadsheet, testid: "export-csv-button", accent: "#06B6D4" },
    { kind: "payouts", title: "Laporan Disbursement", desc: "Riwayat payout, biaya, referensi & status pembayaran.", icon: FileText, testid: "export-payouts-csv-button", accent: "#10B981" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-reports-container">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Laporan & Export</h1>
        <p className="text-muted-foreground mt-1">Unduh data untuk rekonsiliasi, pajak, & audit</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {cards.map((c) => (
          <div key={c.kind} className="bg-card border border-border rounded-xl p-6">
            <div className="h-12 w-12 rounded-lg grid place-items-center mb-4" style={{ background: `${c.accent}22` }}>
              <c.icon className="h-6 w-6" style={{ color: c.accent }} />
            </div>
            <h3 className="font-semibold text-lg">{c.title}</h3>
            <p className="text-sm text-muted-foreground mt-1 mb-4">{c.desc}</p>
            <Button
              data-testid={c.testid}
              onClick={() => exportCsv(c.kind)}
              disabled={loading === c.kind}
              className="bg-primary hover:bg-primary/90 text-white"
            >
              <Download className="h-4 w-4 mr-2" />
              {loading === c.kind ? "Menyiapkan..." : "Export CSV"}
            </Button>
          </div>
        ))}
      </div>

      <div className="bg-card border border-border rounded-xl p-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <h3 className="font-semibold text-lg">Cetak Ringkasan PDF</h3>
            <p className="text-sm text-muted-foreground mt-1">Cetak halaman laporan langsung sebagai PDF melalui browser.</p>
          </div>
          <Button data-testid="export-pdf-button" onClick={printPdf} variant="outline" className="border-border">
            <FileText className="h-4 w-4 mr-2" /> Cetak / Simpan PDF
          </Button>
        </div>
      </div>
    </div>
  );
}
